module.exports = __webpack_public_path__ + "static/img/partner-qmsd.a7bb95c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-qmsd.png
// module id = HPWp
// module chunks = 34